// extracted by mini-css-extract-plugin
export default {"afterPayModeSection":"p--z","refreshPageWarning":"q--z","redirectMessageText":"r--z"};